export default __webpack_public_path__ + "static/media/body-recomp.98c23d0f.png";